import React from 'react';
import './styles/devider.css';

const Devider = () => {
    return (
        <hr className="sidebar-devider" />
    );
}

export default Devider;